import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./product.css";

import { Button, Dropdown, Input, Menu, Segmented, Table } from "antd";
import { useEffect } from "react";

import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { loadRunningSize, searchRunningSize } from "../../redux/actions/product/getAllProductAction";
import GenerateBarcodePopUp from "./generateBarcodePopUp";

function CustomTable({ list, total, setTotal, status }) {
	const dispatch = useDispatch();
	const [columnItems, setColumnItems] = useState([]);
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [currentLimit, setCurrentLimit] = useState(100);

	const handleSearch = (value) => {
		setSearchText(value);
		if (searchTimeout) clearTimeout(searchTimeout);
		const timeout = setTimeout(() => {
			if (value.trim()) {
				dispatch(searchRunningSize(value)).then((count) => {
					if (count !== undefined) setTotal(count);
				});
			} else {
				setCurrentPage(1);
				dispatch(loadRunningSize({ page: 1, limit: currentLimit, status })).then((t) => {
					if (t !== undefined) setTotal(t);
				});
			}
		}, 300);
		setSearchTimeout(timeout);
	};

	const columns = [
		// {
		// 	title: "Image",
		// 	dataIndex: "thumbnail_image_url",
		// 	render: (thumbnail_image_url) => (
		// 		<img
		// 			style={{ maxWidth: "40px" }}
		// 			alt='product'
		// 			src={thumbnail_image_url}
		// 		/>
		// 	),
		// },
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			responsive: ["md"],
		},
		// {
		// 	title: "SKU",
		// 	dataIndex: "sku",
		// 	key: "sku",
		// },
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (name, { id }) => <Link to={`/product/${id}`}>{name}</Link>,
		},
		{
			title: "L",
			dataIndex: "length",
			key: "length",
			sorter: (a, b) => (a.length || 0) - (b.length || 0),
		},
		{
			title: "W",
			dataIndex: "width",
			key: "width",
			sorter: (a, b) => (a.width || 0) - (b.width || 0),
		},
		{
			title: "H",
			dataIndex: "height",
			key: "height",
			sorter: (a, b) => (a.height || 0) - (b.height || 0),
		},
		{
			title: "Unit",
			dataIndex: "unit_type",
			key: "unit_type",
		},
		{
			title: "Sub Category",
			dataIndex: "product_sub_category",
			key: "product_sub_category",
			render: (product_sub_category) => product_sub_category?.name,
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (customer) => customer?.name
		},
		{
			title: "Price",
			dataIndex: "last_sale_price",
			key: "last_sale_price",
			//render: (customer) => product_sub_category?.name
		},
		{
			title: "Ply",
			dataIndex: "ply",
			key: "ply",
			sorter: (a, b) => (a.ply || 0) - (b.ply || 0),
		},
		{
			title: "Printing",
			dataIndex: "is_printing",
			key: "printing",
			render: (val, record) => {
				if (val && record.printing) {
					try {
						const p = typeof record.printing === 'string' ? JSON.parse(record.printing) : record.printing;
						return p.printingType || 'Yes';
					} catch { return 'Yes'; }
				}
				return 'No';
			},
		},
		
		// {
		// 	title: "Brand",
		// 	dataIndex: "product_brand",
		// 	key: "product_brand",
		// 	render: (product_brand) => product_brand?.name,
		// },
		// {
		// 	title: "Quantity",
		// 	dataIndex: "quantity",
		// 	key: "quantity",
		// },

		// {
		// 	title: "Reorder QTY",
		// 	dataIndex: "reorder_quantity",
		// 	key: "reorder_quantity",
		// },
		{
			title: "Action",
			dataIndex: "sku",
			key: "sku",
			render: (sku, quantity) => <GenerateBarcodePopUp sku={sku ? sku : 0} />,
		},
	];

	useEffect(() => {
		setColumnItems(menuItems);
		setColumnsToShow(columns);
	}, []);

	const colVisibilityClickHandler = (col) => {
		const ifColFound = columnsToShow.find((item) => item.key === col.key);
		if (ifColFound) {
			const filteredColumnsToShow = columnsToShow.filter(
				(item) => item.key !== col.key
			);
			setColumnsToShow(filteredColumnsToShow);
		} else {
			const foundIndex = columns.findIndex((item) => item.key === col.key);
			const foundCol = columns.find((item) => item.key === col.key);
			let updatedColumnsToShow = [...columnsToShow];
			updatedColumnsToShow.splice(foundIndex, 0, foundCol);
			setColumnsToShow(updatedColumnsToShow);
		}
	};

	const menuItems = columns.map((item) => {
		return {
			key: item.key,
			label: <span>{item.title}</span>,
		};
	});

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	return (
		<div>
			<div>
				{list && (
					<div style={{ marginBottom: "30px", display: 'flex', gap: 12, alignItems: 'center' }}>
						<Dropdown
							overlay={
								<Menu onClick={colVisibilityClickHandler} items={columnItems} />
							}
							placement='bottomLeft'>
							<Button>Column Visibility</Button>
						</Dropdown>
						<Input.Search
							placeholder='Search by name, customer, sub-category...'
							allowClear
							onChange={(e) => handleSearch(e.target.value)}
							style={{ maxWidth: 400 }}
						/>
					</div>
				)}
			</div>
			<div>
				<Table
					scroll={{ x: true }}
					loading={!list}
					pagination={{
						defaultPageSize: 100,
						current: searchText ? 1 : currentPage,
						pageSizeOptions: [20, 50, 100, 200, 500],
						showSizeChanger: true,
						total: searchText ? list?.length : total,

						onChange: (page, limit) => {
							if (!searchText) {
								setCurrentPage(page);
								setCurrentLimit(limit);
								dispatch(loadRunningSize({ page, limit, status })).then((t) => {
									if (t !== undefined) setTotal(t);
								});
							}
						},
					}}
					columns={columnsToShow}
					dataSource={list ? addKeys(list) : []}
				/>
			</div>
		</div>
	);
}

const GetAllProd = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.products.list);
	const [total, setTotal] = useState(0);

	useEffect(() => {
		dispatch(loadRunningSize({ status: "true", page: 1, limit: 100 })).then((t) => {
			if (t !== undefined) setTotal(t);
		});
	}, []);

	const [status, setStatus] = useState("true");
	const onChange = (value) => {
		setStatus(value);
		dispatch(loadRunningSize({ status: value, page: 1, limit: 100 })).then((t) => {
			if (t !== undefined) setTotal(t);
		});
	};

	const CSVlist = list?.map((i) => ({
		...i,
		product_category: i?.product_category?.name,
	}));

	return (
		<div className='card column-design'>
			<div className='card-body'>
				<h5>Products List</h5>
				{list && (
					<div className='card-title d-flex justify-content-end'>
						<div className='me-2' style={{ marginTop: "4px" }}>
							<CSVLink
								data={CSVlist}
								className='btn btn-dark btn-sm mb-1'
								filename='products'>
								Download CSV
							</CSVLink>
						</div>
						<div>
							<Segmented
								className='text-center rounded danger'
								size='middle'
								options={[
									{
										label: (
											<span>
												<i className='bi bi-person-lines-fill'></i> Active
											</span>
										),
										value: "true",
									},
									{
										label: (
											<span>
												<i className='bi bi-person-dash-fill'></i> Inactive
											</span>
										),
										value: "false",
									},
								]}
								value={status}
								onChange={onChange}
							/>
						</div>
					</div>
				)}

				<CustomTable list={list} total={total} setTotal={setTotal} status={status} />
			</div>
		</div>
	);
};

export default GetAllProd;
